import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent, LoadingComponent, NotificationComponent } from '@shared/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationComponent, LoadingComponent, AlertComponent],
  template: `
    <div class="font-sans antialiased">
      <app-notification #notification></app-notification>
      <app-alert  />
      <app-loading></app-loading>
      <router-outlet />
    </div>
  `,
})
export class AppComponent {
  title = 'app-onioncoop';
}
